export const convertStringToBuffer = str => Uint8Array.from(str, c => c.charCodeAt(0));

export const convertBufferToString = buffer => String.fromCharCode.apply(null, new Uint8Array(buffer));

export const importKey = keyBuffer => crypto.subtle.importKey(
  'spki',
  keyBuffer,
  {
    name: 'RSA-OAEP',
    hash: 'SHA-256',
  },
  false,
  ['encrypt'],
).catch(() => {
  // TODO error handling
  // console.log('importKey error', error);
});

export const encryptValues = (importedKey, valueBuffer) => crypto.subtle.encrypt(
  {
    name: 'RSA-OAEP',
  },
  importedKey,
  valueBuffer,
).catch(() => {
  // TODO error handling
  // console.log('encrypt error', error);
});

export const encrypt = input => async () => {
  const {
    publicKey,
    value,
  } = input;

  // publicKey is base64 encoded so need to decode for use
  const binaryPublicKey = atob(publicKey);

  // key string needs to be an arraybuffer to use in CryptoKey creation
  const keyBuffer = convertStringToBuffer(binaryPublicKey);

  // create a CryptoKey to use with .encrypt
  const importedKey = await importKey(keyBuffer);

  // convert the provided payload values into an arraybuffer for use during encryption
  const valueBuffer = convertStringToBuffer(value);

  // encrypt with our crypto key and value buffer
  const encryptedValueBuffer = await encryptValues(importedKey, valueBuffer);

  // turn the encrypted arraybuffer result into an encrypted binary string
  const encryptedBinaryString = convertBufferToString(encryptedValueBuffer);

  // final step is to base64 encode the payload so it can be sent to the API
  return btoa(encryptedBinaryString);
};

export default encrypt;
